export enum CustodianStatuses {
  AccountOpen = 'ACCOUNT_OPEN',
}
